export default "__VITE_ASSET__NMuknKZe__"